import React from "react";
import { FaTelegram } from "react-icons/fa";

const LINKS = [
  { href: "#services", label: "خدمات" },
  { href: "#pricing", label: "تعرفه‌ها" },
  { href: "#faq", label: "سوالات متداول" },
  { href: "#register", label: "ثبت درخواست" },
  { href: "#royalty", label: "قوانین همکاری" },
];

const TELEGRAM_URL = "https://t.me/yourusername";

export default function Footer() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="relative border-t border-white/5 pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_persian-music-pay/artifacts/a7snz7bp_f2677fb0-9319-4ac7-b749-1aff4f634497.png"
                alt="YouberMusic"
                className="h-12 w-auto select-none mix-blend-lighten"
                draggable="false"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-md">
              سرویس انتشار جهانی موسیقی و دریافت درآمد برای هنرمندان ایرانی.
            </p>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-white mb-4">لینک‌ها</h4>
            <div className="grid grid-cols-2 gap-2">
              {LINKS.map((l, i) => (
                <button
                  key={i}
                  onClick={() => scrollTo(l.href)}
                  data-testid={`footer-link-${i}`}
                  className="text-right text-sm text-slate-400 hover:text-white transition py-1"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-4">ارتباط با ما</h4>
            <a
              href={TELEGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-telegram"
              className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition"
            >
              <FaTelegram className="w-4 h-4 text-cyan-300" />
              <span>تلگرام</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} YouberMusic. تمامی حقوق محفوظ است.</p>
          <p className="max-w-2xl text-center md:text-right leading-relaxed">
            تمام درآمدها، Claimها و انتشار آثار تابع قوانین و بررسی پلتفرم‌های بین‌المللی هستند.
          </p>
        </div>
      </div>
    </footer>
  );
}
